module.exports = __webpack_public_path__ + "img/4.6_Russian_road_sign.cbcf93b0.svg";